import React, { useState, useEffect } from "react";
import NewsCard from "../components/shared/NewsCard";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { useContent } from "../hooks/useContent";
import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
const NewsPage = () => {
  // ----------- hooks ------------
  const { t, i18n } = useTranslation();
  const { news, fetchNews } = useContent();
  const [cards, setCards] = useState([]);

  // ----------- side effect ------------
  useEffect(() => {
    fetchNews(); 
  }, [i18n.language]);

  useEffect(() => {
    const tempCards = [];
    for (let i = 0; i < news.length; i++) {
      tempCards.push(
        <NewsCard
          id={news[i].id}
          small={true}
          img={news[i].image}
          data={news[i]}
        />
      );
    }
    setCards(tempCards);
  }, [news]);
  return (
    <>
    <Header pagetitle={"News"}/>
    <div style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
      <h1 className="m-10 font-semibold text-4xl text-black" >
        {t("Recent news")}
      </h1>
      <div className="flex justify-center flex-row  ">
        <div className="grid  md:grid-cols-2 grid-flow-row gap-10 p-8">
          {cards.map((item, index) => {
            return <div key={index}>{item}</div>;
          })}

          {/* Pagination arrows */}
          <div className="flex flex-row content-start gap-3 self-end">
            <div
              onClick={() => {
                const arr = [...cards];

                const lastElement = arr.shift();

                arr.push(lastElement);
                setCards(arr);
              }}
              className="w-12 h-12 flex items-center cursor-pointer shadow-xl justify-center rounded-full  text-black hover:text-white hover:bg-purple"
            >
              {i18n.language === "ar" ? (
                <BsChevronRight className="text-2xl cursor-pointer" />
              ) : (
                <BsChevronLeft className="text-2xl cursor-pointer" />
              )}
            </div>
            <div
              onClick={() => {
                const arr = [...cards];

                const lastElement = arr.pop();

                arr.unshift(lastElement);
                setCards(arr);
              }}
              className="w-12 h-12 flex items-center cursor-pointer shadow-xl justify-center rounded-full text-black hover:text-white hover:bg-purple"
            >
              {i18n.language === "ar" ? (
                <BsChevronLeft className="text-2xl cursor-pointer" />
              ) : (
                <BsChevronRight className="text-2xl cursor-pointer" />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default NewsPage;
